import { setCurrentUser } from "utils/utils";
import { API_ENDPOINT } from "./Api";
import requestInstance from "./Request"

let env = process.env.REACT_APP_API_BASE_URL

export const locationCheck =  async(data) =>{
    const res = await requestInstance.post(
        `${env}${API_ENDPOINT.GoogleMap.locationCheck}`,data,
    )
    .catch((err) => err.response)
    return setCurrentUser(res)
  }